import { useId } from 'react';

import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconWarning = (iconProps: ChkIconProps) => {
  const clipPathId = useId();

  return (
    <ChkSvgWrapper {...iconProps}>
      <g clipPath={`#url(${clipPathId})`}>
        <path d="M12 8L12 13" stroke="currentColor" strokeWidth="2" />
        <path d="M12 15L12 17" stroke="currentColor" strokeWidth="2" />
        <path
          d="M21.2656 20H2.73445C1.96411 20 1.48306 19.1656 1.86902 18.499L11.1346 2.49483C11.5197 1.82954 12.4803 1.82954 12.8654 2.49482L22.131 18.499C22.5169 19.1656 22.0359 20 21.2656 20Z"
          stroke="currentColor"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </ChkSvgWrapper>
  );
};
